import React from "react";
import BoxComponent from "../../../../../components/Box/BoxComponent";
import TypographyComponent from "../../../../../components/Typography/ThypographyComponent";
import { CategoriasProps } from "../../../../Cardapio/public/CatalogoPage";
import ButtonComponent from "../../../../../components/Button/ButtonComponent";

interface NovoPedidoCategoriaProps {
    categorias: CategoriasProps[];
    categoria: string;
    onChangeCategoria: (categoria: string) => void;
};

const CategoriaComponent = (props: NovoPedidoCategoriaProps) => {
    const handleCategoria = (value: string) => {
        props.onChangeCategoria(value);
    }

    return <BoxComponent
        component="aside"
        sx={{ display: "flex", flexDirection: "column", flex: 1, backgroundColor: "red" }}
    >
        <BoxComponent component="div"
            sx={{
                display: "flex", justifyContent: "space-between", flex: 0.7,
                alignItems: 'center',
                boxSizing: 'border-box',

                background: 'linear-gradient(135deg, #FFFFFF 0%, #F8F5F0 100%)',

                borderBottom: '0.67px solid #E8DFD5',

                paddingRight: '18.06px',
                paddingLeft: '18.06px',

                opacity: 1,
                angle: '0deg'
            }}
        >
            <TypographyComponent variant="h2"
                sx={{
                    fontFamily: '"Font 2", sans-serif',
                    fontWeight: 700,
                    fontSize: '18px',
                    lineHeight: '21.07px',
                    letterSpacing: '0em',
                    color: '#3D2817',
                    display: 'inline-flex',
                    alignItems: 'center',
                    verticalAlign: 'middle',
                    textTransform: 'none'
                }}
            >
                Categorias
            </TypographyComponent>
        </BoxComponent>

        <BoxComponent component="div"
            sx={{
                display: "flex", flexDirection: "column", flex: 9,
                gap: '6.02px',
                opacity: 1,
                boxSizing: 'border-box',

                paddingTop: '12.04px',
                paddingRight: '9.03px',
                paddingBottom: '12.04px',
                paddingLeft: '9.03px',

                background: '#FFFFFF',
                borderRight: '0.67px solid #E8DFD5',
            }}
        >
            {props.categorias.map((element: CategoriasProps, index: number) => {
                const isAtivo = element.value === props.categoria;

                return <ButtonComponent
                    id={`cat-${element.value.toLowerCase()}`}
                    key={`cat-${element.value.toLowerCase()}`}
                    onClick={() => handleCategoria(element.value)}
                    sx={{
                        // width: '173.94px',
                        height: '40.06px',
                        display: 'flex',
                        justifyContent: "flex-start",
                        alignItems: 'center',
                        gap: '9.03px',
                        boxSizing: 'border-box',
                        borderRadius: '6.02px',
                        backgroundColor: isAtivo ? '#E5E7EB' : "transparent",

                        padding: '9.03px 12.04px',

                        boxShadow: isAtivo ? '0px 1.51px 6.02px 0px rgba(61, 40, 23, 0.08)' : "",

                        opacity: 1,
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            backgroundColor: '#D1D5DB',
                        }
                    }}
                >
                    <BoxComponent component="div" sx={{
                        height: 17, width: 17
                    }}>

                    </BoxComponent>
                    <TypographyComponent variant="body1" sx={{
                        fontFamily: '"Font 1", sans-serif',
                        fontWeight: 600,
                        fontSize: 12,
                        lineHeight: '15.05px',
                        letterSpacing: '0em',
                        color: isAtivo ? '#FF8C42' : '#3D2817',
                        display: 'inline-flex',
                        alignItems: 'center',
                        verticalAlign: 'middle',
                        textTransform: 'none'
                    }}>
                        {element.label}
                    </TypographyComponent>
                </ButtonComponent>
            })}
        </BoxComponent>
    </BoxComponent>
}

export default CategoriaComponent;